module.exports = __webpack_public_path__ + "587e1b5a23686c91c7d13f1a2bac05a0.png";